import React, { useState, useCallback } from "react";

export const useModalSystem = () => {
    const [modals, setModals] = useState<React.ReactNode[]>([]);
    
    const callModal = useCallback((render: (close: () => void) => React.ReactNode) => {
        let modalView: React.ReactNode;
        const close = () => setModals(m => m.filter(n => n !== modalView));
        modalView = render(close);
        setModals(m => [...m, modalView]);
    }, []);
    
    return { modals, callModal };
};